import { render, staticRenderFns } from "./ReceivedRecordings.vue?vue&type=template&id=15da4586&scoped=true"
import script from "./ReceivedRecordings.vue?vue&type=script&lang=js"
export * from "./ReceivedRecordings.vue?vue&type=script&lang=js"
import style0 from "./ReceivedRecordings.vue?vue&type=style&index=0&id=15da4586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da4586",
  null
  
)

export default component.exports